import { z } from "zod";
import { UK_FILTER_DEFINITIONS_ARRAY } from "./uk/uk-parcel-search-schema";
import { LocationsAIResponse } from "./common/location-matches-schema";
import { US_FILTER_DEFINITIONS_ARRAY } from "./us/us-parcel-search-filters";

// Shared base schema as a Zod object
const BaseAIFilterSchema = z.object({
  reason: z.string(),
  filterNotAvailable: z.boolean(),
});

export const UK_FILTER_SCHEMA = BaseAIFilterSchema.extend({
  filters: UK_FILTER_DEFINITIONS_ARRAY,
});

export const US_FILTER_SCHEMA = BaseAIFilterSchema.extend({
  filters: US_FILTER_DEFINITIONS_ARRAY,
});

export type UkSourcingFilterSchema = z.infer<typeof UK_FILTER_SCHEMA>;

export type UsSourcingFilterSchema = z.infer<typeof US_FILTER_SCHEMA>;

export type AIFilterSchema = UkSourcingFilterSchema | UsSourcingFilterSchema;

export type AIFilterSchemaWithLocation = AIFilterSchema & LocationsAIResponse;
